import { Heading } from '@sparemin/blockhead';
import { useBreakpoints } from 'context/BreakpointsContext';
import { audioPlayerUtils } from 'pages/AudioPlayerPage/state';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AudioPlayerLink } from '../../state/AudioPlayerContext/types';
import styles from './TrackInfo.module.scss';

type TrackInfoVariant = 'primary' | 'secondary';

export type TrackInfoLinkProps = {
  data: string | AudioPlayerLink | undefined;
  variant: TrackInfoVariant;
};

const TrackInfoLink: React.FC<TrackInfoLinkProps> = ({ data, variant }) => {
  const { md } = useBreakpoints();

  const location = useLocation();

  const isLinkConfig = audioPlayerUtils.isAudioPlayerLink(data);
  const pathname = isLinkConfig ? data.path.pathname : undefined;
  const isOnPage = location.pathname === pathname;

  const headingProps =
    variant === 'primary'
      ? ({ level: 2, weight: 500 } as const)
      : ({ level: 4, weight: 400 } as const);

  const text = (
    <Heading {...headingProps}>{isLinkConfig ? data.value : data}</Heading>
  );

  if (data && isLinkConfig && !isOnPage && !md) {
    const { path, navOpts, onClick } = data;

    return (
      <Link
        className={styles.link}
        to={path ?? ''}
        onClick={onClick}
        {...navOpts}
      >
        {text}
      </Link>
    );
  }
  return text;
};

export default TrackInfoLink;
